// @flow
import React from 'react';
import type { Node } from 'react';
import styled, { type StyledComponent } from 'styled-components';

import { ALIGNMENT } from '../layout.constants';

export type Props = {
  children: Node,
  style?: Object,
  vAlign?: ALIGNMENT,
  hAlign?: ALIGNMENT,
};

const VerticalWrapper: StyledComponent<{ vAlign: ALIGNMENT, hAlign: ALIGNMENT }> = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: ${props => props.vAlign.toString()};
  align-items: ${props => props.hAlign.toString()};
`;

const VerticalLayout = React.forwardRef<Props, typeof VerticalWrapper>((props: Props, ref) => (
  <VerticalWrapper ref={ref} {...props}>
    {props.children}
  </VerticalWrapper>
));

// $FlowFixMe
VerticalLayout.defaultProps = {
  style: {},
  vAlign: ALIGNMENT.START,
  hAlign: ALIGNMENT.START,
};

export default VerticalLayout;



// WEBPACK FOOTER //
// ../react-lib/src/components/layouts/VerticalLayout/VerticalLayout.jsx